import React from 'react';

import iconexplore from '../Assets/icons/icon-explore.svg'
import iconeco from '../Assets/icons/icon-eco.svg'
import iconhome from '../Assets/icons/icon-home.svg'
import iconmarket from '../Assets/icons/icon-market.svg'
import iconmarketdataset from '../Assets/icons/icon-market-dataset.svg'
import iconnewsevent from '../Assets/icons/icon-news-events.svg'
import iconpredict from '../Assets/icons/icon-predict.svg'
import iconproject from '../Assets/icons/icon-project.svg'
import iconsecure from '../Assets/icons/icon-secure.svg'
import iconsettings from '../Assets/icons/icon-settings.svg'
import icongeo from '../Assets/icons/icon-geo.svg'
import iconsupport from '../Assets/icons/icon-support.svg'

import icongrid from '../Assets/icons/icon-grid.svg'
import iconlist from '../Assets/icons/icon-list.svg'
import iconsearch from '../Assets/icons/icon-search.svg'
// Crear un mapeo entre los nombres y las rutas de los recursos
const imageIconMap: any = {
  iconexplore,
  iconeco,
  iconhome,
  iconmarket,
  iconmarketdataset,
  iconnewsevent,
  iconpredict,
  iconproject,
  iconsecure,
  iconsettings,
  iconsupport,
  icongeo,
  icongrid,
  iconlist,
  iconsearch







};

interface ImageIconLoaderProps {
  name: string;
  alt?: string;
  className?: string;
  width: number;
}

const ImageIconLoader: React.FC<ImageIconLoaderProps> = ({ name, alt = '', className = '', width }) => {
  const src = imageIconMap[name];
  return <img src={src} alt={alt} className={className} width={width} />;
};

export default ImageIconLoader;
